import { getServiceLocationDisplayName } from '@breezy/shared'
import { ServiceLocationReadError } from '../../../components/ServiceLocationReadError'
import { useStrictContext } from '../../../utils/react-utils'
import {
  EstimateDataContext,
  type EstimateLocation,
  type EstimatePointOfContact,
  EstimatesContext,
} from '../estimatesFlowUtils'

export const EstimateServiceIdentityContent = ({
  location,
  pointOfContact,
}: {
  location?: EstimateLocation
  pointOfContact?: EstimatePointOfContact
}) =>
  location ? (
    <section
      aria-label="Service Address"
      data-testid="estimate-service-identity"
      className="mb-4 rounded-xl border border-solid border-bz-border bg-white p-4"
    >
      <div className="font-semibold">Service Address</div>
      {pointOfContact?.fullName && <div>{pointOfContact.fullName}</div>}
      {getServiceLocationDisplayName(location.name, location.line1) && (
        <div className="whitespace-normal font-semibold [overflow-wrap:anywhere]">
          {getServiceLocationDisplayName(location.name, location.line1)}
        </div>
      )}
      <div>{location.line1}</div>
      {location.line2 && <div>{location.line2}</div>}
      <div>
        {location.city}, {location.stateAbbreviation} {location.zipCode}
      </div>
      {pointOfContact && <div>{[pointOfContact.phoneNumber, pointOfContact.email].filter(Boolean).join(' • ')}</div>}
    </section>
  ) : null

export const EstimateServiceIdentity = () => {
  const { serviceLocation, serviceLocationReadError, retryServiceLocation } = useStrictContext(EstimatesContext)
  const { location, pointOfContact } = useStrictContext(EstimateDataContext)
  const identity = serviceLocation ? { ...serviceLocation.address, name: serviceLocation.displayName } : location
  return (
    <>
      <ServiceLocationReadError isError={!!serviceLocationReadError} retry={() => retryServiceLocation?.()} />
      <EstimateServiceIdentityContent location={identity} pointOfContact={pointOfContact} />
    </>
  )
}
